const sizeMap = {
  uk: 'page_size',
  fr: 'size',
  de: 'size',
};
const DEFAULT_PAGE = {
  uk: 1,
  fr: 0,
  de: 0,
};

const NUM_RESULTS = 18;

const VEHICLE_STATUS_VALUES = {
  includeSold: 'active,inactive',
  excludeSold: 'active',
};
const FILTERS_TO_RESET = ['page'];
export { DEFAULT_PAGE, NUM_RESULTS, sizeMap, VEHICLE_STATUS_VALUES, FILTERS_TO_RESET };
